<template>
  <div class="m-candidate-status">
    <b-modal v-model="localActive" size="sm" centered hide-footer hide-header @close="closeModal">
      <div class="candidate__status-icon">
        <candidates-status-icon
          :status="candidate.state"
          :scheduled-time="{ date: candidate.statusDate, time: candidate.statusTime }"
        />
      </div>
      <svg
        class="m-candidate-status-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closeModal"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-candidate-status-content">
        <h3 class="candidate__fullname">{{ candidate.fio }}</h3>
        <div class="candidate__position">{{ candidate.post }}</div>
        <div v-if="candidate.filial" class="candidate__filial">{{ candidate.filial.filial_name }}</div>
        <div class="candidate__status__wrapper">
          <div class="candidate__status" :style="backgroundColor">{{ candidateStatus }}</div>
          <candidates-scheduled-date
            v-if="candidate.statusDate && candidate.statusTime"
            :status-id="candidate.status.id"
            :date="`${candidate.statusDate}\xa0${candidate.statusTime}`"
          />
        </div>
        <div v-if="candidate.accountable" class="candidate__referral">
          <img :src="candidate.accountable.photo || defaultAvatar" :alt="404" @error="replaceImageOnErrorLoad" />
          <div @click="goToWorker">
            {{ candidate.accountable.name }}
          </div>
        </div>
        <div v-if="candidate.status.reason" class="candidate__rejection-reason">{{ candidate.status.reason.name }}</div>
        <div v-if="candidate.status.comment" class="candidate__comment" style="text-overflow: ellipsis;overflow-x: hidden">{{ candidate.status.comment }}</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CandidatesStatusIcon from "@/pages/staff/candidates/components/candidates-status-icon";
import CandidatesScheduledDate from "@/pages/staff/candidates/components/candidates-scheduled-date";
import defaultAvatar from "@/assets/images/userpic.svg";
import candidateStatusMixin from "@/mixins/candidateStatusMixin";

export default {
  name: "candidate-status-modal",
  components: {
    CandidatesScheduledDate,
    CandidatesStatusIcon,
  },
  mixins: [candidateStatusMixin],
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
    candidateId: {
      type: Number,
      default: () => -1,
    },
  },
  data() {
    return {
      localActive: false,
      candidate: {},
      defaultAvatar,
    };
  },
  computed: {
    ...mapGetters({
      getCandidateById: "candidates/getCandidateById",
    }),
    candidateStatus() {
      if (this.candidate.dateOfStatusChange) {
        return `${this.candidate.status.name} (${this.candidate.dateOfStatusChange})`;
      }

      return `${this.candidate.status.name}`;
    },
    backgroundColor() {
      const color = this.getStatusColor(this.candidate.status.id);

      if (color) {
        return `background-color: ${color}`;
      }

      return `background-color: ${this.cellColors.default}`;
    },
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
  },
  created() {
    this.candidate = this.getCandidateById(this.candidateId);
  },

  methods: {
    closeModal() {
      this.localActive = false;
      this.$emit("close");
    },
    goToWorker() {
      const routeData = this.$router.resolve({ path: `/personal-employee/${this.candidate.accountable.id}/summary` });
      window.open(routeData.href, "_blank");
    },
    replaceImageOnErrorLoad(e) {
      e.target.src = defaultAvatar;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

::v-deep .c-icon svg {
  top: 2px;
  left: 0;
}

::v-deep .modal-body {
  padding: 25px;
}

.m-candidate-status {
  &-close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
}
.candidate {
  &__status-icon {
    position: absolute;
    top: 0;
    left: 6px;
  }
  &__fullname {
    font-size: 15px;
    margin-bottom: 3px;
    line-height: 1.08;
  }
  &__position,
  &__filial,
  &__comment,
  &__status,
  &__status-scheduled-date,
  &__referral div {
    font-size: 13px;
  }
  &__status-scheduled-date,
  &__referral div {
    font-weight: 500;
  }
  &__filial {
    color: $color-label;
    margin-bottom: 14px;
    margin-top: -2px;
  }
  &__status-scheduled-date {
    display: flex;
    margin-top: 8px;
  }
  &__status__wrapper {
    width: fit-content;
    margin-bottom: 15px;
  }
  &__status {
    padding: 3px 5px;
    max-width: 173px;
    line-height: 1.2;
  }
  &__referral {
    display: flex;
    align-items: center;
    margin-bottom: 13px;
    & img {
      border-radius: 999px;
      margin-right: 9px;
      width: 34px;
      height: 34px;
    }
    & div {
      cursor: pointer;
      line-height: 1.08;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__rejection-reason {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
  }
}
</style>
